import React from 'react'
import PropTypes from 'prop-types'
import { cn } from 'lib/utils'
import { Check } from 'lucide-react'

export const AdasStepper = ({ activeStep, children, className, alternativeLabel, orientation = 'horizontal', sx, ...props }) => {
  const steps = React.Children.toArray(children)
  return (
    <div className={cn('flex', orientation === 'vertical' ? 'flex-col gap-0' : 'flex-row items-center', className)} {...props}>
      {steps.map((child, index) => React.cloneElement(child, { stepIndex: index, activeStep, key: index }))}
    </div>
  )
}

export const AdasStep = ({ children, className, stepIndex, activeStep, sx, ...props }) => {
  const steps = React.Children.toArray(children)
  return (
    <div className={cn('flex flex-col items-center flex-1', className)} {...props}>
      {steps.map((child, i) => (React.isValidElement(child) ? React.cloneElement(child, { stepIndex, activeStep, key: i }) : child))}
    </div>
  )
}

export const AdasStepLabel = ({ children, className, stepIndex, activeStep, completed, sx, ...props }) => {
  const isActive = stepIndex === activeStep
  const isDone = stepIndex < activeStep || completed
  return (
    <div className={cn('flex flex-col items-center gap-1', className)} {...props}>
      <div
        className={cn(
          'w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium border-2',
          isDone && 'bg-primary border-primary text-white',
          isActive && 'border-primary text-primary bg-white',
          !isDone && !isActive && 'border-gray-300 text-gray-400 bg-white'
        )}
      >
        {isDone ? <Check className='w-4 h-4' /> : stepIndex + 1}
      </div>
      <span className={cn('text-xs mt-1', isActive ? 'text-primary font-medium' : 'text-text-secondary')}>{children}</span>
    </div>
  )
}

AdasStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  alternativeLabel: PropTypes.bool,
  orientation: PropTypes.string
}
AdasStep.propTypes = { children: PropTypes.node, className: PropTypes.string, stepIndex: PropTypes.number, activeStep: PropTypes.number }
AdasStepLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  stepIndex: PropTypes.number,
  activeStep: PropTypes.number,
  completed: PropTypes.bool
}
